import {
    addNewUser,
    deleteUser,
    getAllUsers,
    getAllBuyers,
    signInUser,
    updateUser,
    updateUserProfile,
    verifyNumber,
    getAllPrintableUsers,
    getAUserByToken,
} from '../../services/userService'
import { errorHandler } from '../../utils/errorHandler'
import { notification } from '../notification/notificationActions'
import { userTypes } from './userTypes'
import axios from 'axios'

export const setUser = user => ({
    type: userTypes.SET_USER,
    user,
})

export const logOut = () => ({
    type: userTypes.LOGOUT_USER,
    payload: {},
})

export const userSignIn = body => dispatcch => {
    dispatcch({
        type: userTypes.SIGN_IN_START,
    })
    try {
    } catch (error) {
        dispatcch({
            type: userTypes.SIGN_IN_FAILED,
        })
    }
}

//user Info
export const getAUserByTokenAction = () => async dispatch => {
    dispatch({
        type: userTypes.GET_A_USER_BY_TOKEN_START,
    })
    try {
        const { data } = await getAUserByToken()
        dispatch({
            type: userTypes.GET_A_USER_BY_TOKEN_SUCCESS,
            payload: data?.data,
        })
    } catch (error) {
        dispatch(logOut())
        // errorHandler(dispatch, userTypes.GET_A_USER_BY_TOKEN_FAILED, error)
    }
    dispatch({
        type: userTypes.GET_A_USER_BY_TOKEN_END,
    })

    dispatch({
        type: userTypes.GET_A_USER_BY_TOKEN_END,
    })
}

export const loginRegisterAction = (
    body,
    setPhoneNumberAction,
    setStep
) => async dispatch => {
    dispatch({
        type: userTypes.SIGN_IN_START,
    })
    try {
        const { data } = await signInUser(body)
        dispatch({
            type: userTypes.SIGN_IN_SUCCESS,
        })
        dispatch(
            notification({
                message: `کد برای شماره ${body.phone_number} ارسال شد`,
                variant: 'success',
            })
        )
        setPhoneNumberAction(body.phone_number)
        setStep(2)
    } catch (error) {
        errorHandler(dispatch, userTypes.SIGN_IN_FAILED, error)
    }
    dispatch({
        type: userTypes.SIGN_IN_END,
    })
}

export const verifyNumberAction = (body, history) => async dispatch => {
    dispatch({
        type: userTypes.VERIFY_NUMBER_START,
    })
    try {
        const { data } = await verifyNumber(body)
        dispatch({
            type: userTypes.VERIFY_NUMBER_SUCCESS,
            payload: data?.data,
        })
        dispatch(
            notification({
                message: 'ورود با موفقیت انجام شد',
                variant: 'success',
            })
        )
        axios.defaults.headers.common[
            'Authorization'
        ] = `Bearer ${data?.data?.access_token}`
        const firebase= localStorage.getItem('najva_user_token')
        if (firebase) axios.defaults.headers.common['Firebase'] = firebase
        history.push('/dashboard')
    } catch (error) {
        errorHandler(dispatch, userTypes.VERIFY_NUMBER_FALIED, error)
    }

    dispatch({
        type: userTypes.VERIFY_NUMBER_END,
    })
}

export const resendCodeAction = body => async dispatch => {
    dispatch({
        type: userTypes.RESEND_CODE_START,
    })
    try {
        const { data } = await signInUser(body)
        dispatch(
            notification({
                message: `کد برای شماره ${body.phone_number} ارسال شد`,
                variant: 'success',
            })
        )
    } catch (error) {
        errorHandler(dispatch, userTypes.RESEND_CODE_FAILED, error)
    }
    dispatch({
        type: userTypes.RESEND_CODE_END,
    })
}

export const getAllUsersAction = body => async dispatch => {
    dispatch({
        type: userTypes.GET_ALL_USERS_START,
    })
    try {
        const { data } = await getAllUsers(body)
        // const { data: allData } = await getAllPrintableUsers(body);

        dispatch({
            type: userTypes.GET_ALL_USERS_SUCCESS,
            payload: data?.data,
            printableUsers: [],
            meta: data?.meta,
        })
    } catch (error) {
        errorHandler(dispatch, userTypes.GET_ALL_USERS_FAILED, error)
    }
    dispatch({
        type: userTypes.GET_ALL_USERS_END,
    })
}

export const getAllBuyersAction = id => async dispatch => {
    dispatch({
        type: userTypes.GET_ALL_BUYERS_START,
    })
    try {
        const { data } = await getAllBuyers(id)
        dispatch({
            type: userTypes.GET_ALL_BUYERS_SUCCESS,
            payload: data?.data,
            meta: data?.meta,
        })
    } catch (error) {
        errorHandler(dispatch, userTypes.GET_ALL_BUYERS_FAILED, error)
    }
    dispatch({
        type: userTypes.GET_ALL_BUYERS_END,
    })
}

// --------------------edit user

export const updateUserAction = (id, body, closeModal) => async (
    dispatch,
    getState
) => {
    const { allUsers } = getState().user
    const index = allUsers.findIndex(selectedUser => selectedUser.id === id)
    dispatch({
        type: userTypes.UPDATE_A_USERS_START,
    })
    try {
        const { data } = await updateUser(id, body)
        allUsers[index] = data?.data
        dispatch({
            type: userTypes.UPDATE_A_USERS_SUCCESS,
            payload: allUsers,
        })
        dispatch(
            notification({
                message: 'کاربر مورد نظر با موفقیت ویرایش شد',
                variant: 'gold',
            })
        )
        closeModal && closeModal()
    } catch (error) {
        errorHandler(dispatch, userTypes.UPDATE_A_USERS_FAILED, error, allUsers)
    }
    dispatch({
        type: userTypes.UPDATE_A_USERS_END,
    })
}

export const addUserAction = (body, closeModal) => async (
    dispatch,
    getState
) => {
    dispatch({
        type: userTypes.ADD_A_USERS_START,
    })
    try {
        await addNewUser(body)
        closeModal && closeModal()

        const { data } = await getAllUsers({
            name: '',
            take: 10,
            skip: 0,
            name_dir: '',
            created_at_dir: 'DESC',
        })

        dispatch({
            type: userTypes.ADD_A_USERS_SUCCESS,
            payload: data.data,
        })
        dispatch(
            notification({
                message: 'کاربر جدید با موفقیت ثبت شد',
                variant: 'success',
            })
        )
    } catch (error) {
        errorHandler(dispatch, userTypes.ADD_A_USERS_FAILED, error)
    }
    dispatch({
        type: userTypes.ADD_A_USERS_END,
    })
}

export const deleteUserAction = (id, closeModal) => async (
    dispatch,
    getState
) => {
    const { allUsers } = getState().user
    const filteredUsers = allUsers.filter(user => user.id !== id)
    dispatch({
        type: userTypes.DELETE_A_USERS_START,
    })
    try {
        const { data } = await deleteUser(id)
        dispatch({
            type: userTypes.DELETE_A_USERS_SUCCESS,
            payload: filteredUsers,
        })
        dispatch(
            notification({
                message: 'کاربر مورد نظر با موفقیت حذف شد',
                variant: 'success',
            })
        )
        closeModal && closeModal()
    } catch (error) {
        errorHandler(dispatch, userTypes.DELETE_A_USERS_FAILED, error, allUsers)
    }
    dispatch({
        type: userTypes.DELETE_A_USERS_END,
    })
}

export const updateAUserProfileAction = (
    body,
    closeModal
) => async dispatch => {
    dispatch({
        type: userTypes.UPDATE_A_USER_PROFILE_START,
    })
    try {
        const { data } = await updateUserProfile(body)
        dispatch({
            type: userTypes.UPDATE_A_USER_PROFILE_SUCCESS,
            payload: data?.data,
        })
        closeModal && closeModal()
    } catch (error) {
        errorHandler(dispatch, userTypes.UPDATE_A_USER_PROFILE_FAILED, error)
    }
    dispatch({
        type: userTypes.UPDATE_A_USER_PROFILE_END,
    })
}
